import { CMSConnector } from 'umg-cms-js-sdk/src'

export const cms = new CMSConnector()
